import type { CSSProperties, ReactNode } from "react";

type RuntimeChartGeometryAttributes = { style: CSSProperties };

interface RuntimeChartSegmentProps {
  end: number;
  start: number;
  children: (attributes: RuntimeChartGeometryAttributes) => ReactNode;
}

interface RuntimeChartTranslateProps {
  offset: number;
  children: (attributes: RuntimeChartGeometryAttributes) => ReactNode;
}

interface RuntimeChartLeftProps {
  left: CSSProperties["left"];
  children: (attributes: RuntimeChartGeometryAttributes) => ReactNode;
}

interface RuntimeSvgXProps {
  x: CSSProperties["x"];
  children: (attributes: RuntimeChartGeometryAttributes) => ReactNode;
}

/** Positions a chart segment from geometry calculated against a live container width. */
export function RuntimeChartSegment({ end, start, children }: RuntimeChartSegmentProps): ReactNode {
  return children({ style: { width: `${end - start}px`, transform: `translateX(${start}px)` } });
}

/** Applies a live horizontal compensation without exposing a general style prop. */
export function RuntimeChartTranslate({ offset, children }: RuntimeChartTranslateProps): ReactNode {
  return children({ style: { transform: `translateX(${offset}px)` } });
}

/** Positions chart content using a value calculated from live chart data. */
export function RuntimeChartLeft({ left, children }: RuntimeChartLeftProps): ReactNode {
  return children({ style: { left } });
}

/** Applies an SVG x value that requires CSS functions unsupported by the SVG attribute. */
export function RuntimeSvgX({ x, children }: RuntimeSvgXProps): ReactNode {
  return children({ style: { x } });
}
